/** Home page reducer actions */
export const HOME_ACTIONS = {
    LOADING : "loading",
    ERROR: "error",
    CUSTOMERSLIST: "customers_list",
    SELECTEDCUSTOMER:'selected_customer',
    SEARCHCUSTOMER:'search_customer'
}

